import { API_BASE_URL } from "../constants/appConstants";
import { authenticatedRequest } from './authService';


const Dashboard_BASE_URL = `${API_BASE_URL}/dashboard`;

// Service for dashboard API calls

// Fetch records breakdown for donut chart
export async function fetchRecordsBreakdown({ period = 'all', startDate, endDate } = {}) {
  let url = `${Dashboard_BASE_URL}/records-breakdown/?period=${period}`;
  if (period === 'range' && startDate && endDate) {
    url += `&start_date=${startDate}&end_date=${endDate}`;
  }
  const response = await authenticatedRequest(url, {
    headers: { 'Accept': 'application/json' }
  });
  // if (!response.ok) {
  //   let errorData;
  //   try {
  //     errorData = await response.json();
  //   } catch (e) {
  //     errorData = { detail: response.statusText };
  //   }
  //   const errorMessage = errorData.detail || `HTTP error! status: ${response.status}`;
  //   throw new Error(`Failed to fetch records breakdown: ${errorMessage}`);
  // }
  return response;
}

export async function fetchDashboardSummary() {
  const url = `${Dashboard_BASE_URL}/summary/`;
  const response = await authenticatedRequest(url, {
    headers: { 'Accept': 'application/json' }
  });
  // if (!response.ok) {
  //   let errorData;
  //   try {
  //     errorData = await response.json();
  //   } catch (e) {
  //     errorData = { detail: response.statusText };
  //   }
  //   const errorMessage = errorData.detail || `HTTP error! status: ${response.status}`;
  //   throw new Error(`Failed to fetch dashboard summary: ${errorMessage}`);
  // }
  return response;
}

export async function fetchRecentReports() {
  const url = `${Dashboard_BASE_URL}/recent-reports/`;
  const response = await authenticatedRequest(url, {
    headers: { 'Accept': 'application/json' }
  });
  // if (!response.ok) {
  //   let errorData;
  //   try {
  //     errorData = await response.json();
  //   } catch (e) {
  //     errorData = { detail: response.statusText };
  //   }
  //   const errorMessage = errorData.detail || `HTTP error! status: ${response.status}`;
  //   throw new Error(`Failed to fetch recent reports: ${errorMessage}`);
  // }
  return response;
}

// Fetch the 4 most recent accepted collaborators for the dashboard
export async function fetchRecentCollaborators() {
  const url = `${Dashboard_BASE_URL}/recent-collaborators/`;
  const response = await authenticatedRequest(url, {
    headers: { 'Accept': 'application/json' }
  });

  return response;
}



// // Fetch the recent activities of a login user
// export async function fetchRecentActivities() {
//   const url = `${Dashboard_BASE_URL}/recent-activities/`;
//   const response = await authenticatedRequest(url, {
//     headers: { 'Accept': 'application/json' }
//   });
//   if (!response.ok) {
//     let errorData;
//     try {
//       errorData = await response.json();
//     } catch (e) {
//       errorData = { detail: response.statusText };
//     }
//     const errorMessage = errorData.detail || `HTTP error! status: ${response.status}`;
//     throw new Error(`Failed to fetch recent collaborators: ${errorMessage}`);
//   }
//   return response.json();
// }



// Fetch all activities performed by the current user
export async function fetchMyActivities() {
  const url = `${Dashboard_BASE_URL}/my-activities/`;
  const response = await authenticatedRequest(url, {
    headers: { 'Accept': 'application/json' }
  });
  // if (!response.ok) {
  //   let errorData;
  //   try {
  //     errorData = await response.json();
  //   } catch (e) {
  //     errorData = { detail: response.statusText };
  //   }
  //   const errorMessage = errorData.detail || `HTTP error! status: ${response.status}`;
  //   throw new Error(`Failed to fetch my activities: ${errorMessage}`);
  // }
  return response;
}



// Fetch all activities performed on reports owned by the current user
export async function fetchReportActivities() {
  const url = `${Dashboard_BASE_URL}/report-activities/`;
  const response = await authenticatedRequest(url, {
    headers: { 'Accept': 'application/json' }
  });
  // if (!response.ok) {
  //   let errorData;
  //   try {
  //     errorData = await response.json();
  //   } catch (e) {
  //     errorData = { detail: response.statusText };
  //   }
  //   const errorMessage = errorData.detail || `HTTP error! status: ${response.status}`;
  //   throw new Error(`Failed to fetch report activities: ${errorMessage}`);
  // }
  return response;
}